import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { selectCheckoutPaymentMethod, setInsufficientHouseChargeBalance } from "redux/actions";
import "./payment-method.scss";
import { useParams } from "react-router-dom";

const PaymentMethod = () => {
  const dispatch = useDispatch();
  const { checkoutType } = useParams();
  const isCateringMeal = checkoutType === "catering-meal"

  const [paymentMethod, setPaymentMethod] = useState();

  const { storeDetails } = useSelector(({ store }) => store);
  const { checkoutStoreType, ebtPaymentPaidList, checkoutPickupType } = useSelector(
    ({ checkout }) => checkout
  );

  const { cateringAndMealKitProductCartList, productCartList } = useSelector(
    ({ cartWishlist }) => cartWishlist
  );

  const isEbtProductAvailable = productCartList.some(
    (product) => product.ebt_item === "1"
  );

  const {
    pickup_cc = "0",
    pickup_cod = "0",
    delivery_cc = "0",
    delivery_cod = "0",
    catering_pickup_cc = "0",
    catering_pickup_cod = "0",
    catering_delivery_cc = "0",
    catering_delivery_cod = "0",
    allow_delivery_default_payment_method = "",
    allow_pickup_default_payment_method = "",
    allow_catering_pickup_default_payment_method = "0",
    allow_catering_delivery_default_payment_method = "0",
    allow_mealkit_default_pickup_payment_method = "0",
    allow_pickup_ebt = "0",
    allow_delivery_ebt = "0",
    allow_mealkit_pickup_cc = "0",
    allow_mealkit_pickup_cod = "0",
  } = storeDetails || {};
  
  const commonDetailsData = useSelector(({ common }) => common.commonDetailsData);
  const allowHouseCharge = commonDetailsData?.header_section?.allow_house_charge === "1"
  let {
    allow_ecom_pickup_house_charge = "0",
    allow_ecom_delivery_house_charge = "0",

    allow_catering_pickup_house_charge = "0",
    allow_catering_delivery_house_charge = "0",

    allow_mealkit_asap_pickup_house_charge = "0",
    allow_mealkit_schedule_pickup_house_charge = "0",
  } = storeDetails || {};

  if (!allowHouseCharge) {
    allow_ecom_pickup_house_charge = "0"
    allow_ecom_delivery_house_charge = "0"

    allow_catering_pickup_house_charge = "0"
    allow_catering_delivery_house_charge = "0"

    allow_mealkit_asap_pickup_house_charge = "0"
    allow_mealkit_schedule_pickup_house_charge = "0"
  }

  const { is_mealkit = "0" } = cateringAndMealKitProductCartList[0] || {};

  const { cartAmountDetails, isFollowedEbtPayment, cateringAndMealkitCartAmountDetails } = useSelector(({ checkout }) => checkout)

  const { data: { price_list = [] } = {} } =
    cartAmountDetails || {};

  const houseChargeAmount =  (isCateringMeal ? +cateringAndMealkitCartAmountDetails?.house_charge_amount : +cartAmountDetails?.house_charge_amount) || 0
  useEffect(() => {
    const itemPriceList = isCateringMeal ? cateringAndMealkitCartAmountDetails?.data?.price_list : price_list
    const orderAmount = +itemPriceList?.find(list => list.key_name === "grand_total")?.amount || 0;
    const insufficientHouseChargeBalance = orderAmount > houseChargeAmount;
    dispatch(setInsufficientHouseChargeBalance(insufficientHouseChargeBalance));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartAmountDetails, dispatch]);

  useEffect(() => {
    //grocery
    if (!isCateringMeal) {
      if (isStorePickup) {
        var pickupDefaultPaymentMethod =
          isEbtProductAvailable && ebtPaymentPaidList.length === 0
            ? "ebt"
            : allow_pickup_default_payment_method;
        setPaymentMethod(pickupDefaultPaymentMethod);
        dispatch(selectCheckoutPaymentMethod(pickupDefaultPaymentMethod));
      }
      if (isDelivery) {
        var deliveryDefaultPaymentMethod =
          isEbtProductAvailable && ebtPaymentPaidList.length === 0
            ? "ebt"
            : allow_delivery_default_payment_method;
        setPaymentMethod(deliveryDefaultPaymentMethod);
        dispatch(selectCheckoutPaymentMethod(deliveryDefaultPaymentMethod));
      }
    }

    //mealkit
    if (isCateringMeal && is_mealkit === "1") {
      setPaymentMethod(allow_mealkit_default_pickup_payment_method);
      dispatch(selectCheckoutPaymentMethod(allow_mealkit_default_pickup_payment_method));
    }

    //catering
    if (isCateringMeal && is_mealkit === "2") {
      if (isStorePickup) {
        setPaymentMethod(allow_catering_pickup_default_payment_method);
        dispatch(
          selectCheckoutPaymentMethod(
            allow_catering_pickup_default_payment_method
          )
        );
      } else {
        setPaymentMethod(allow_catering_delivery_default_payment_method);
        dispatch(
          selectCheckoutPaymentMethod(
            allow_catering_delivery_default_payment_method
          )
        );
      }
    }
  }, [checkoutStoreType, storeDetails]); // eslint-disable-line

  const handleChange = (e) => {
    const { value } = e.target;
    setPaymentMethod(value);
    dispatch(selectCheckoutPaymentMethod(value));
  };

  const authorizedAmountObj =
    price_list &&
    price_list.find(
      (list) =>
        list.key_name ===
        (isFollowedEbtPayment
          ? "total_final_payable_amount"
          : "authorized_amount")
    );

  const isStorePickup = checkoutStoreType === "store_pickup"
  const isDelivery = checkoutStoreType === "delivery"

  const houseChargeProps = {
    handleChange,
    paymentMethod,
    houseChargeAmount
  }

  return (
    <div className="payment-method-section">
      <h1>
        <strong>Choose payment method</strong>
      </h1>
      {isEbtProductAvailable && ebtPaymentPaidList.length === 0 && (
        <div className="radio-alignment">
          {/* grocery */}
          {!isCateringMeal &&
            (allow_delivery_ebt === "1" || allow_pickup_ebt === "1") && (
              <div>
                <input
                  type="radio"
                  value="ebt"
                  id="ebt"
                  name="paymentMethod"
                  onChange={handleChange}
                  checked={paymentMethod === "ebt"}
                />
                <label htmlFor="ebt">Pay with EBT SNAP</label>
              </div>
            )}
        </div>
      )}

      {/* grocery */}
      {!isCateringMeal && (
        <div className="radio-alignment">
          {((isStorePickup && pickup_cc === "1") ||
            (isDelivery && delivery_cc === "1")) && (
              <div style={{ display: "flex" }}>
                <div>
                  <input
                    type="radio"
                    value="cc"
                    id="credit-card"
                    name="paymentMethod"
                    onChange={handleChange}
                    checked={paymentMethod === "cc"}
                  />
                  <label htmlFor="credit-card">Credit Card</label>
                </div>
                {ebtPaymentPaidList && !!ebtPaymentPaidList.length ? (
                  <div
                    className="balance-to-pay"
                    style={{ color: "var(--bg-danger)", marginLeft: "1rem" }}
                  >
                    (Balance to pay : $
                    {authorizedAmountObj && authorizedAmountObj.amount})
                  </div>
                ) : (
                  ""
                )}
              </div>
            )}
        </div>
      )}

      {/* grocery */}
      {!isCateringMeal && ebtPaymentPaidList.length === 0 && (
        <>
        <div className="radio-alignment">
          {/* Checkout Page COD Label added Dynamically - Card Num : 1634 - 07/02/2023  - Madhu */}
          {(isStorePickup && pickup_cod === "1") || 
           (isDelivery && delivery_cod === "1") ? (
            <div>
              <input
                type="radio"
                value="cod"
                id="COD"
                name="paymentMethod"
                onChange={handleChange}
                checked={paymentMethod === "cod"}
              />
              <label htmlFor="COD">{isStorePickup ? storeDetails.pickup_cod_lable : storeDetails.delivery_cod_lable}</label>
            </div>
          ) : null}
        </div>
        <div className="radio-alignment  housecharge">
          {(isStorePickup && allow_ecom_pickup_house_charge === "1") || 
           (isDelivery && allow_ecom_delivery_house_charge === "1") ? (
            <HouseCharge {...houseChargeProps} />
          ) : null}
        </div>
        </>
      )}

      {/* mealkit */}
      {isCateringMeal && is_mealkit === "1" && isStorePickup && (
        <>
          {allow_mealkit_pickup_cc === "1" && (
            <div className="radio-alignment">

              <div>
                <input
                  type="radio"
                  value="cc"
                  id="credit-card"
                  name="paymentMethod"
                  onChange={handleChange}
                  checked={paymentMethod === "cc"}
                />
                <label htmlFor="credit-card">Credit Card</label>
              </div>
            </div>
          )}
          {allow_mealkit_pickup_cod === "1" && (
            <div className="radio-alignment">
              <div>
                <input
                  type="radio"
                  value="cod"
                  id="COD"
                  name="paymentMethod"
                  onChange={handleChange}
                  checked={paymentMethod === "cod"}
                />
                <label htmlFor="COD">{storeDetails.pickup_cod_lable}</label>
              </div>
            </div>
          )}
          {(allow_mealkit_asap_pickup_house_charge === "1" && checkoutPickupType === "asap") ||
           (allow_mealkit_schedule_pickup_house_charge === "1" && checkoutPickupType === "later")
            ? <HouseCharge {...houseChargeProps} />
            : null
          }
        </>
      )}

      {/* catering pickup*/}
      {isCateringMeal && is_mealkit === "2" && isStorePickup && (
          <div className="radio-alignment">
            {catering_pickup_cc === "1" && (
              <div>
                <input
                  type="radio"
                  value="cc"
                  id="credit-card"
                  name="paymentMethod"
                  onChange={handleChange}
                  checked={paymentMethod === "cc"}
                />
                <label htmlFor="credit-card">Credit Card</label>
              </div>
            )}
          </div>
        )}
      {isCateringMeal && is_mealkit === "2" && isStorePickup && (
        <>
          <div className="radio-alignment">
            {catering_pickup_cod === "1" && (
              <div>
                <input
                  type="radio"
                  value="cod"
                  id="COD"
                  name="paymentMethod"
                  onChange={handleChange}
                  checked={paymentMethod === "cod"}
                />
                <label htmlFor="COD">{storeDetails.pickup_cod_lable}</label>
              </div>
            )}
          </div>
          <div className="radio-alignment">
            {allow_catering_pickup_house_charge === "1" && (
              <HouseCharge {...houseChargeProps} />
            )}
          </div>
        </>
        )}

      {/* catering delivery*/}
      {isCateringMeal &&
        is_mealkit === "2" &&
        isDelivery && (
          <div className="radio-alignment">
            {catering_delivery_cc === "1" && (
              <div>
                <input
                  type="radio"
                  value="cc"
                  id="credit-card"
                  name="paymentMethod"
                  onChange={handleChange}
                  checked={paymentMethod === "cc"}
                />
                <label htmlFor="credit-card">Credit Card</label>
              </div>
            )}
          </div>
        )}
      {isCateringMeal && is_mealkit === "2" && isDelivery && (
        <>
          <div className="radio-alignment">
            {catering_delivery_cod === "1" && (
              <div>
                <input
                  type="radio"
                  value="cod"
                  id="COD"
                  name="paymentMethod"
                  onChange={handleChange}
                  checked={paymentMethod === "cod"}
                />
                <label htmlFor="COD">{storeDetails.delivery_cod_lable}</label>
              </div>
            )}
          </div>
          <div className="radio-alignment">
            {allow_catering_delivery_house_charge === "1" && (
              <HouseCharge {...houseChargeProps} />
            )}
          </div>
        </>
        )}
      
    </div>
  );
};

function HouseCharge({handleChange, paymentMethod, houseChargeAmount}) {
  const { insufficientHouseChargeBalance } = useSelector(({ checkout }) => checkout);
  return (<><div>
    <input
      type="radio"
      value="house_charge"
      id="house_charge"
      name="paymentMethod"
      onChange={handleChange}
      checked={paymentMethod === "house_charge"}
    />
    <label htmlFor="house_charge">House Charge </label>
    <div className="item-value">(Balance: ${houseChargeAmount})</div>
  </div>
  {insufficientHouseChargeBalance && <div className="error-text" style={{ left: "27px" }}>Insufficient house charge balance</div>}
  </>
  )
}

export default PaymentMethod;
